import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app-auth/services/authentication.service';
import { AccessService } from '@app-core/services/access/access.service';
import { DataService } from '@app-core/services/data/data.service';
import { LoginTypes } from '@app-core/services/google-tag-manager/google-tag-manager.service';
import { CLIENT_CONFIG } from '@config/config';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { finalize, takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-fleet-manager-login',
  templateUrl: './fleet-manager-login.component.html',
  styleUrls: ['./fleet-manager-login.component.scss'],
})
export class FleetManagerLoginComponent implements OnInit, OnDestroy {
  public errorOccured = false;
  public errorMessage = '';
  public clientName = CLIENT_CONFIG.clientName;
  public loading = true;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accessService: AccessService,
    public authService: AuthenticationService,
    private dataService: DataService,
    public translate: TranslateService,
    public dialog: MatDialog
  ) {}

  public ngOnInit() {
    this.authService.loader = true;
    this.listenParams();
  }

  private listenParams() {
    this.route.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params: any) => this.validateCode(params));
  }

  private validateCode({ code, error = '', source = '', redirectRoute = '' }) {
    if (error) {
      this.errorOccured = true;
      this.errorMessage = `${
        error === 'unauthorized'
          ? this.translate.instant('fleetManagerloginAccessDenied')
          : this.translate.instant('fleetManagerloginSomeThingWntWrong')
      }, ${this.translate.instant('fleetManagerloginRefreshingPage')}`;
      // Delaying logout just to give user some time to read the error message.this.translate.instant('liveViewComponentConnected')
      setTimeout(() => {
        this.authService.logout();
      }, 3000);
    } else if (code || this.isValidCustomLogin()) {
      let redirectToPage = 'home';
      if (source && source === 'companion_app_login' && redirectRoute) {
        redirectToPage = redirectRoute;
      } else {
        redirectToPage = 'home';
      }

      const params = {
        customerName: this.clientName,
        ...(code && { code }),
      };

      const headers = {};
      if (this.isValidCustomLogin()) {
        let token = '';
        const companion_app_token = localStorage.getItem('companion-app-access-token');
        if (companion_app_token) {
          token = companion_app_token;
          headers['token'] = token;
        } else {
          token = this.router.getCurrentNavigation()?.extras?.state?.token;
          headers['token'] = token;
        }
      }

      this.authService
        .intermediateServerLogin(params, headers)
        .pipe(
          finalize(() => (this.authService.loader = false)),
          takeUntil(this.ngUnsubscribe)
        )
        .subscribe(
          (res) => {
            this.accessService.setLoginInfo(res);
            this.dataService.userLogin.next({
              loginInfo: res,
              loginType: LoginTypes.fleetManager,
              directLogin: true,
              redirectUrl: redirectToPage,
            });
            //for ios users in companion app
            const companion_app_token = localStorage.getItem('companion-app-access-token');
            if (companion_app_token) {
              const w = window as any;
              w?.webkit?.messageHandlers?.nativeReload.postMessage('user is logged in reload the page');
            }

            this.authService.scheduleAccessTokenRefresh(res.tokenExpiresAt);
          },
          () => {
            this.authService.logout();
          }
        );
    } else if (this.accessService.hasValidToken()) {
      this.dataService.userLogin.next();
    } else {
      this.authService.redirectToLandingPage();
    }
  }

  private isValidCustomLogin() {
    if (this.accessService.hasValidToken()) {
      return false;
    }
    const companion_app_token = localStorage.getItem('companion-app-access-token') || null;

    if (companion_app_token) {
      return !!companion_app_token && companion_app_token?.length > 0;
    }

    const token = this.router.getCurrentNavigation()?.extras?.state?.token;
    return !!token && token?.length > 0;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
